import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isBrowser } from 'ws-scripts/modules/environment';
import { closeFullscreenMobileSubnav } from '../actions/menu';

/**
 * Custom hook that monitors the cms-web slidein panel and resets fullscreen
 * mobile subnav state when the panel becomes inactive. Watches for class
 * changes on the #ddc-slidein-panel element.
 *
 * @param {Object} navRef - React ref to the navigation element (unused but kept for API consistency)
 * @param {string} deviceType - Current device type ('MOBILE' or 'DESKTOP')
 */
export const useNavigationVisibilityReset = (navRef, deviceType) => {
	const dispatch = useDispatch();
	const wasActiveRef = useRef(false);
	const fullscreenSubnavOpen = useSelector(
		(state) => state.menu.fullscreenMobileSubnavOpen
	);

	useEffect(() => {
		if (!isBrowser || deviceType !== 'MOBILE') {
			return () => {};
		}

		const slideinPanel = document.getElementById('ddc-slidein-panel');
		if (!slideinPanel) return () => {};

		const checkPanelState = () => {
			const isActive = slideinPanel.classList.contains('active');
			const isInactive = slideinPanel.classList.contains('inactive');

			if (wasActiveRef.current && isInactive && fullscreenSubnavOpen) {
				dispatch(closeFullscreenMobileSubnav());
			}

			wasActiveRef.current = isActive;
		};

		const observer = new MutationObserver(checkPanelState);

		observer.observe(slideinPanel, {
			attributes: true,
			attributeFilter: ['class']
		});

		checkPanelState();

		return () => observer.disconnect();
	}, [dispatch, deviceType, fullscreenSubnavOpen]);
};
